'use client';

import { redirect } from 'next/navigation';

export default function TermsRedirect() {
  // Get the user's language from localStorage (default to 'ar')
  const language = localStorage.getItem('i18nextLng') || 'ar';

  // Redirect /terms-and-conditions → language-specific Terms page
  redirect(`/${language}/terms-and-conditions`);
}
